import { Menu, MenuProps } from '@mui/material'

export type MolsonMenuProps = {
  dataTestId?: string
} & MenuProps

export const MolsonMenu = ({
  dataTestId,
  children,
  ...props
}: MolsonMenuProps) => {
  return (
    <Menu data-testid={dataTestId} {...props}>
      {children}
    </Menu>
  )
}
